import { fetchUsers } from '@/core/api/users'

export default {
  namespaced: true,
  state: {
    loading: false,
    items: [],
  },
  actions: {
    async FETCH({ commit }) {
      commit('START_REQUEST')

      const data = await fetchUsers()
      commit('SET', data)
    },
  },
  mutations: {
    START_REQUEST: state => {
      state.loading = true
    },
    CLEAR: state => {
      state.items = []
    },
    SET: (state, items) => {
      state.items = items
      state.loading = false
    },
  },
}
